import DeleteUsedAssemblyMaterial from './DeleteUsedAssemblyMaterial';

export default DeleteUsedAssemblyMaterial;